import { OfferStage } from 'api';
export const offerStageArr = [
    { stage: OfferStage.Draft, position: 'first', state: 'active' },
    {
        stage: OfferStage.Prepared,
        position: 'middle',
        state: 'inactive'
    },
    { stage: OfferStage.Sent, position: 'middle', state: 'inactive' },
    { stage: OfferStage.Won, position: 'middle', state: 'inactive' },
    { stage: OfferStage.Lost, position: 'middle', state: 'inactive' },
    { stage: OfferStage.Canceled, position: 'last', state: 'inactive' }
];
